module.exports = __webpack_public_path__ + "public/img/img-mobile-yec-2.406f117e.png";